import { render, staticRenderFns } from "./BlogDetailedView.vue?vue&type=template&id=24c0c382&scoped=true"
import script from "./BlogDetailedView.vue?vue&type=script&lang=js"
export * from "./BlogDetailedView.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailedView.vue?vue&type=style&index=0&id=24c0c382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c0c382",
  null
  
)

export default component.exports